<template>
  <div>
    <!-- ============================================================== -->
    <!-- Page wrapper  -->
    <!-- ============================================================== -->
    <div class="page-wrapper">
      <!-- ============================================================== -->
      <!-- Container fluid  -->
      <!-- ============================================================== -->
      <div class="container-fluid">
        <!-- ============================================================== -->
        <!-- Bread crumb and right sidebar toggle -->
        <!-- ============================================================== -->
        <div class="row page-titles">
          <div class="col-md-5 align-self-center">
            <h4 class="text-themecolor">Payments Paid</h4>
          </div>
          <div class="col-md-7 align-self-center text-right">
            <div class="d-flex justify-content-end align-items-center">
              <ol class="breadcrumb">
                <li class="breadcrumb-item">
                  <a href="/">Home</a>
                </li>
                <li class="breadcrumb-item active">Payments Paid</li>
              </ol>
            </div>
          </div>
        </div>

        <div class="row justify-content-end">
          <div class="col-12">
            <form class="floating-labels">
              <div class="row">
                <div class="col-2">
                  <div class="form-group m-b-40"
                  >
                   <span class="p-float-label">
                     <InputText
                      type="text"
                      id=""
                      placeholder=""
                      v-model="filter.externalId"
                      class="float-class1"
                      style="width:100%;"
                    />
                    <label style="margin-top:-4.5px; !important" id="font1">External ID</label>
                      </span>
                  </div>
                </div>
                <div class="col-2">
                  <div class="form-group m-b-40"
                   >
                    <span class="p-float-label">
                     <InputText
                     id="practiceName"
                     maxlength="50"
                     type="text"
                     v-model="filter.firstName"
                      @keyup="performFilter()"
                     class="float-class1"
                     style="width:100%;"
                    />
                  <label style="margin-top:-4.5px; !important" id="font1" for="">Search By First Name</label>
                  </span>
                  </div>
                </div>
                <div class="col-2">
                  <div class="form-group m-b-40"
                  >
                     <span class="p-float-label">
                     <InputText
                     id="practiceName"
                     maxlength="50"
                     type="text"
                      v-model="filter.lastName"
                      @keyup="performFilter()"
                     class="float-class1"
                     style="width:100%;"
                    />
                 <label style="margin-top:-4.5px; !important" id="font1">Search By Last Name</label>
                  </span>
                  </div>
                </div>
                <div class="col-2">
                  <div class="form-group m-b-40"
                   >
                      <span class="p-float-label">
                     <InputText
                      v-mask="'###-###-####'"
                      type="tel"
                      id=""
                      placeholder=""
                      v-model="filter.phone"
                      @keyup="performFilter()"
                     class="float-class1"
                     style="width:100%;"
                    />
                    <label style="margin-top:-4.5px; !important" id="font1">Search By Phone</label>
                    </span>
                  </div>
                </div>
                <div class="col-2">
                  <div class="form-group m-b-40">
                    <InputText
                      type="date"
                      class="float-class1"
                      id=""
                      v-model="filter.monthYear"
                      style="width:85%;"
                    /><span class="bar"></span>
                  </div>
                </div>
<div class="col-2">
            <div class="form-group m-b-40">
              <InputText
                style="width:110%; margin-left: -30px;"
                type="text"
                class="float-class1"
                name="daterange"
                :value="initDate"
                @focus="datePicker"
                @change="datePicker"
              />
              <div class="input-group-append">
                <span
                  class="input-group-text"
                  style="margin-left:159px;margin-top:-42px;height"
                >
                  <span class="ti-calendar"></span>
                </span>
              </div>
            </div>
          </div>
              </div>
            </form>
          </div>
        </div>

        <div class="card p-3">
          <div class="table-responsive">
            <div class="dataTables_wrapper container-fluid dt-bootstrap4 no-footer">
                <div class="dataTables_length">
                  <span style="margin-right: 10px"><label for="">Show </label>
                  </span>
                  <select v-model="pageSize" class="form-control form-control-sm" aria-label="Default select example"
                    @change="pageChange(1)">
                    <option selected>50</option>
                    <option value="100">100</option>
                    <option value="500">500</option>
                    <option value="1000">500</option>
                    <option value="2000">2000</option>
                  </select>

                  <span style="margin-left: 10px">
                    <label for=""> Entries </label></span>
                </div>
                <!-- <div class="dataTables_filter">
                  <span class="float-right">
                    <span style="margin-right: 10px"><label for="Search">Search:</label></span>
                    <input type="text" @change="SearchDataTable()" v-model="filter" name="" id="" />
                  </span>
                </div> -->
              </div>
            <table
              data-height="300"
              id="table001"
              class="
                table
                display
                table-bordered
                text-center
                table-striped
                no-wrap
              "
            >
              <thead class="thead-dark">
                <tr>
                  <th style="text-align:start;">Full Name <span> <button class="asc-desc-btn" @click="orderBy(1)">&uarr;
                          &darr;</button> </span></th>
                  <th style="text-align:start;">Date of Service <span> <button class="asc-desc-btn" @click="orderBy(2)">&uarr;
                          &darr;</button> </span></th>
                  <th style="text-align:start;">Date Requested <span> <button class="asc-desc-btn" @click="orderBy(3)">&uarr;
                          &darr;</button> </span></th>
                  <th style="text-align:start;">Sent To <span> <button class="asc-desc-btn" @click="orderBy(4)">&uarr;
                          &darr;</button> </span></th>
                  <th style="text-align:start;">Amount Requested <span> <button class="asc-desc-btn" @click="orderBy(5)">&uarr;
                          &darr;</button> </span></th>
                  <th style="text-align:start;">Status <span> <button class="asc-desc-btn" @click="orderBy(6)">&uarr;
                          &darr;</button> </span></th>
                </tr>
              </thead>

              <tbody>
                <tr
                  v-for="(pay, ndx01) in filteredPaymentRequests"
                  :key="ndx01"
                >
                  <td>
                    <div class="btn-group">
                      <button
                        type="button"
                        class="btn btn-success"
                        @click="showPatientProfilePopup(pay)"
                      >
                        {{ pay.firstName + " " + pay.lastName }} <br /><strong
                          >{{ pay.dob }}</strong
                        >
                      </button>
                      <button
                        v-if="updButton == 1"
                        type="button"
                        class="
                          btn btn-success
                          dropdown-toggle dropdown-toggle-split
                        "
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                        @click="dropdownButtonClick(pay)"
                      >
                        <span class="sr-only">Toggle Dropdown</span>
                      </button>
                             <button
                        v-else
                        type="button"
                        class="
                          btn btn-success
                          dropdown-toggle dropdown-toggle-split
                        "
                        :disabled="updButton == 0"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                        @click="dropdownButtonClick(pay)"
                      >
                        <span class="sr-only">Toggle Dropdown</span>
                      </button>
                      <div class="dropdown-menu animated flipInY">
                        <a
                          class="dropdown-item"
                          href="javascript:void(0)"
                          @click="refundClick(pay)"
                          >Refund</a
                        >
                      </div>
                    </div>
                  </td>
                  <td>{{ pay.dos }}</td>
                  <td>{{ pay.billDate }}</td>
                  <td>
                    <div>
                      <span class="bs-label label-danger badgeBorder">
                        {{ pay.email }}
                      </span>
                    </div>
                    <br />
                    <div>
                      <span class="bs-label label-danger badgeBorder">
                        {{ pay.phone }}
                      </span>
                    </div>
                  </td>
                  <td>{{ pay.amountStr }} $</td>
                  <td>
                    <div class="form-group">
                      <select
                        class="form-control"
                        v-model="pay.status"
                        disabled
                      >
                        <option value="1" hidden>Sent</option>
                        <option value="2" hidden>Pending</option>
                        <option value="3" hidden>Disputed</option>
                        <option value="4" disabled>Paid</option>
                      </select>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
           <nav aria-label="Page navigation " style="float:right">
              <span style="padding-left:40px;" v-if="totalRows < pageSize * pageNumber ">showing {{totalRows}} of {{totalRows}} records</span>
               <span style="padding-left:40px;" v-else>showing {{pageSize * pageNumber }} of {{totalRows}} records</span>
              <ul class="pagination" style="float:right;">
                <li class="page-item colorActive">
                  <span v-if="pageNumber==1">
                    <button disabled class="page-link disabledColor" @click="pageChange('Previous')">Previous</button>
                  </span>
                  <span v-else>
                    <button class="page-link " @click="pageChange('Previous')">Previous</button>
                  </span>
                </li>

                <li v-for="pageNum in totalPages" :key="pageNum" class="page-item colorActive">
                  <span v-if="pageNumber==pageNum"><button class="page-link activeColor" disabled
                      @click="pageChange(pageNum)">{{pageNum}} </button> </span>
                  <span v-else> <button class="page-link" @click="pageChange(pageNum)">{{pageNum}} </button></span>
                </li>

                <li class="page-item colorActive">
                  <span v-if="pageNumber==totalPages">
                    <button disabled class="page-link disabledColor" @click="pageChange('Next')">Next</button>
                  </span>
                  <span v-else>
                    <button class="page-link" @click="pageChange('Next')">Next</button>
                  </span>
                </li>
              </ul>
            </nav>
        </div>
        <!-- ============================================================== -->
      </div>
      <!-- ============================================================== -->
      <!-- End Container fluid  -->
      <!-- ============================================================== -->
    </div>
    <!-- ============================================================== -->
    <!-- End Page wrapper  -->
    <!-- ============================================================== -->

    <!-- $$**$$ Begin -->
    <div
      class="modal fade"
      id="newptModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel"
      aria-hidden="true"
      style="display: none"
      data-keyboard="false" data-backdrop="static"
    >
      <div class="modal-dialog cascading-modal modal-lg">
        <div class="modal-content" style="width: 158% !important; left: -200px">
          <PatientComponent v-bind:propTarget="propPatientSource" @destroyProp = "changeVAL">
          </PatientComponent>
        </div>
      </div>
    </div>
    <!-- $$**$$ End -->
  </div>
</template>

<script>
import axios from "axios";
import Swal from "sweetalert2";
import PatientComponent from "../views/Patients/PatientComponent.vue"; // $$**$$

export default {
  name: "PaymentRequest",

// $$**$$
  components: {
    PatientComponent,
  },

  data() {
    return {
      EmployeeRolesStr: [],
      updButton: 1,
      delButton: 1,

      //loader
      loader: "",
      //Timer
      TimerObject: {},

      allPaymentRequests: "",
      filteredPaymentRequests: "",

      filter: {
        externalId: "",
        firstName: "",
        lastName: "",
        phone: "",
        monthYear: "",
        dateFull: "",
      },

      aSinglePaymentReceived: {
        pndx: 0,
        patientId: 0,
        practiceId: 0,
        visitId: 0,
        billNo: 0,
        collectedBy: 0,
        paymentDate: new Date(),
        amount: 0,
        paymentMethod: "",
        holderName: "",
        tdNumber: "",
        cardCVC: "",
        comment: "",
        zip: "",
      },
      //DataTable Default Variables
        pageNumber: 1,
        pageSize: 50,
        orderByCol: 1, // if orderby number is same do opposite
        asc_desc: "asc", //remember what asv and desc
        remeberOrder: "",
        firstTime: true,
        totalPages: 0,
        totalRows: 0,
        DataTable: {},
        lastErrorCode: {},

      initDate: "",
      startDate: "",
      endDate: "",

      propPatientSource: { visitId: 0, patientId: 0, updButton: 1 }, //-- $$**$$
    }; // data return
  }, // data

  methods: {
    changeVAL(){
 this.propPatientSource = { visitId: 0, patientId: 0, updButton: 1 }
    },
    //--$$**$$
    showPatientProfilePopup(pay) { 
      if (pay.visitId > 0 || pay.patientId > 0) {
        this.propPatientSource.visitId = pay.visitId;
        this.propPatientSource.patientId = pay.patientId;
        this.propPatientSource.updButton = this.updButton;

        $("#newptModal").modal("show");
      }
    },

handleRole(){
   this.EmployeeRolesStr = localStorage.EmployeeRolesStr;
   this.EmployeeRolesStr = JSON.parse(this.EmployeeRolesStr);
    if(this.EmployeeRolesStr.length > 0){
       this.val = this.EmployeeRolesStr.filter(
      (i)=>i.name == 'Paid'
     );
       if(this.val[0].canUpdate == 0){ this.updButton = 0;}
       if(this.val[0].canDelete == 0){ this.delButton = 0;}
}
},

    //Timer
     //Timer
   StartLogoutTime() {
      this.TimerObject = setTimeout(() => {
        this.AutoLogout();
      }, this.LogoutTime);
    },
    ResetLogoutTime() {
      clearTimeout(this.TimerObject);
      this.TimerObject = setTimeout(() => {
        this.AutoLogout();
      }, this.LogoutTime);
    },

    refundClick(pay) {
      Swal.fire({
        title: "Are you sure?",
        text:
          "You are about to refund $" +
          this.aSinglePayment.amountStr +
          ". This action cannot be undone. Are you sure you want to continue?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#00c292",
        confirmButtonText: "Continue",
        allowOutsideClick: false,
        allowEscapeKey: false,
      }).then((result) => {
        if (result.value) {
          this.intDummyComm();
          this.dummyComm.visitId = pay.visitId;
          this.dummyComm.patientId = pay.patientId;
          const url = this.SERVER + "/VNSPRAAPI/Trackers/RefundPayment";
          
          this.axiosGetData(url, this.dummyComm, 100);
          console.log("REFUND: ", pay);

          this.performFilter();
        }
      }); // swal
    },

 loader_1() {
    this.loader = this.$loading.show({
            // Optional parameters
              color: '#03a9f3'
            });
 },

    dropdownButtonClick(pay) {
      this.aSinglePayment = JSON.parse(JSON.stringify(pay));
    },

    datePicker() {
      let ss = this;
      $('input[name="daterange"]').daterangepicker(
        {
          opens: "left",
        },
        function (start, end) {
          ss.startDate = new Date(start);
          ss.endDate = new Date(end);
          ss.initDate =
            ss.dateToMDY(ss.startDate) + " - " + ss.dateToMDY(ss.endDate);
        }
      );
    },

    performFilter() {
      if (this.allPaymentRequests.length < 1) return;
      const obj = JSON.parse(JSON.stringify(this.allPaymentRequests));
      //alert(this.filter.firstName);

      if (this.filter.externalId.length > 0) {
        this.filteredPaymentRequests = obj.filter((f) =>
          (f.externalId + " ").includes(this.filter.externalId)
        );
      } else {
        this.filteredPaymentRequests = obj.filter(
          (f) =>
            f.firstName
              .toLowerCase()
              .startsWith(this.filter.firstName.toLowerCase().trim()) &&
            f.lastName
              .toLowerCase()
              .startsWith(this.filter.lastName.toLowerCase().trim()) &&
            f.phone.toLowerCase().startsWith(this.filter.phone.toLowerCase().trim())
        );
      }
    },

    loadInit() {
      this.endDate = new Date();
      this.startDate = new Date();
      this.startDate.setDate(this.startDate.getDate() - 27);
      this.endDate.setDate(this.endDate.getDate() + 1);
      this.initDate =
        this.dateToMDY(this.startDate) + " - " + this.dateToMDY(this.endDate);

      this.intDummyComm();
      this.dummyComm.myTime = "range";
      this.dummyComm.extras1 = this.dateToYMD(this.startDate);
      this.dummyComm.extras2 = this.dateToYMD(this.endDate);
      this.dummyComm.pageNumber = this.pageNumber;
      this.dummyComm.pageSize = this.pageSize;

      const url = this.SERVER + "/VNSPRAAPI/Trackers/GetActivePaidPaymentsList";

      this.axiosGetData(url, this.dummyComm, 1);

      this.performFilter();
      this.StartLogoutTime();
    },
     //code for Data-Tables_
      pageChange(obj) {
        if (obj == "Next") {
          if (this.pageNumber < this.totalPages) {
            this.pageNumber += 1;
          }
        } else if (obj == "Previous" && this.pageNumber != 1) {
          this.pageNumber -= 1;
        } else {
          this.pageNumber = obj;
        }
        this.endDate = new Date();
      this.startDate = new Date();
      this.startDate.setDate(this.startDate.getDate() - 7);
      this.endDate.setDate(this.endDate.getDate() + 1);
      this.initDate =
        this.dateToMDY(this.startDate) + " - " + this.dateToMDY(this.endDate);

       this.intDummyComm();
      this.dummyComm.myTime = "range";
      this.dummyComm.extras1 = this.dateToYMD(this.startDate);
      this.dummyComm.extras2 = this.dateToYMD(this.endDate);
      this.dummyComm.pageNumber = this.pageNumber;
      this.dummyComm.pageSize = this.pageSize;

      const url = this.SERVER + "/VNSPRAAPI/Trackers/GetActivePaidPaymentsList";

      this.axiosGetData(url, this.dummyComm, 1);
      },
       orderBy(column) {
        if (this.firstTime == true) {
          this.firstTime = false;
          return;
        }
        this.orderByCol = column;
        if (column == 1) {
          if (this.asc_desc == "asc") {
            this.asc_desc = "desc";
            this.filteredPaymentRequests = this.filteredPaymentRequests.sort((a, b) => (a.firstName < b.firstName) ? 1 : ((b.firstName < a.firstName) ? -1 :
              0));
          } else {
            this.asc_desc = "asc";
            this.filteredPaymentRequests = this.filteredPaymentRequests.sort((a, b) => (a.lastName > b.lastName) ? 1 : ((b.lastName > a.lastName) ? -1 :
              0))
          }

        }
        if (column == 2) {
          if (this.asc_desc == "asc") {
            this.asc_desc = "desc";
            this.filteredPaymentRequests = this.filteredPaymentRequests.sort((a, b) => (a.dos < b.dos) ? 1 : ((b.dos < a.dos) ? -1 : 0));
          } else {
            this.asc_desc = "asc";
            this.filteredPaymentRequests = this.filteredPaymentRequests.sort((a, b) => (a.dos > b.dos) ? 1 : ((b.dos > a.dos) ? -1 : 0))
          }
        }
        if (column == 3) {
          if (this.asc_desc == "asc") {
            this.asc_desc = "desc";
            this.filteredPaymentRequests = this.filteredPaymentRequests.sort((a, b) => (a.billDate < b.billDate) ? 1 : ((b.billDate < a.billDate) ? -1 : 0));
          } else {
            this.asc_desc = "asc";
            this.filteredPaymentRequests = this.filteredPaymentRequests.sort((a, b) => (a.billDate > b.billDate) ? 1 : ((b.billDate > a.billDate) ? -1 : 0))
          }
        }
        if (column == 4) {
          if (this.asc_desc == "asc") {
            this.asc_desc = "desc";
            this.filteredPaymentRequests = this.filteredPaymentRequests.sort((a, b) => (a.email < b.email) ? 1 : ((b.email < a
              .email) ? -1 : 0));
          } else {
            this.asc_desc = "asc";
            this.filteredPaymentRequests = this.filteredPaymentRequests.sort((a, b) => (a.email > b.email) ? 1 : ((b.email > a
              .email) ? -1 : 0))
          }
        }
        if (column == 5) {
          if (this.asc_desc == "asc") {
            this.asc_desc = "desc";
            this.filteredPaymentRequests = this.filteredPaymentRequests.sort((a, b) => (a.phone < b.phone) ? 1 : ((b.phone < a
              .phone) ? -1 : 0));
          } else {
            this.asc_desc = "asc";
            this.filteredPaymentRequests = this.filteredPaymentRequests.sort((a, b) => (a.phone > b.phone) ? 1 : ((b.phone > a
              .phone) ? -1 : 0))
          }
        }
        if (column == 6) {
          if (this.asc_desc == "asc") {
            this.asc_desc = "desc";
            this.filteredPaymentRequests = this.filteredPaymentRequests.sort((a, b) => (a.amountStr < b.amountStr) ? 1 : ((b.amountStr < a.amountStr) ? -1 : 0));
          } else {
            this.asc_desc = "asc";
            this.filteredPaymentRequests = this.filteredPaymentRequests.sort((a, b) => (a.amountStr > b.amountStr) ? 1 : ((b.amountStr > a.amountStr) ? -1 : 0))
          }
        }
      },

      orderByRemeber(column) {
        this.orderByCol = column;
        if (column == 1) {
          if (this.asc_desc == "asc") {
            this.filteredPaymentRequests = this.filteredPaymentRequests.sort((a, b) => (a.firstName < b.firstName) ? 1 : ((b.firstName < a.firstName) ? -1 :
              0));
          } else {
            this.filteredPaymentRequests = this.filteredPaymentRequests.sort((a, b) => (a.lastName > b.lastName) ? 1 : ((b.lastName > a.lastName) ? -1 :
              0))
          }
        }
        if (column == 2) {
          if (this.asc_desc == "asc") {
            this.filteredPaymentRequests = this.filteredPaymentRequests.sort((a, b) => (a.dos < b.dos) ? 1 : ((b.dos < a.dos) ? -1 : 0));
          } else {
            this.filteredPaymentRequests = this.filteredPaymentRequests.sort((a, b) => (a.dos > b.dos) ? 1 : ((b.dos > a.dos) ? -1 : 0))
          }
        }
        if (column == 3) {
          if (this.asc_desc == "asc") {
            this.filteredPaymentRequests = this.filteredPaymentRequests.sort((a, b) => (a.billDate < b.billDate) ? 1 : ((b.billDate < a.billDate) ? -1 : 0));
          } else {
            this.filteredPaymentRequests = this.filteredPaymentRequests.sort((a, b) => (a.billDate > b.billDate) ? 1 : ((b.billDate > a.billDate) ? -1 : 0))
          }
        }
        if (column == 4) {
          if (this.asc_desc == "asc") {
            this.filteredPaymentRequests = this.filteredPaymentRequests.sort((a, b) => (a.email < b.email) ? 1 : ((b.email < a
              .email) ? -1 : 0));
          } else {
            this.filteredPaymentRequests = this.filteredPaymentRequests.sort((a, b) => (a.email > b.email) ? 1 : ((b.email > a
              .email) ? -1 : 0))
          }
        }
        if (column == 5) {
          if (this.asc_desc == "asc") {
            this.filteredPaymentRequests = this.filteredPaymentRequests.sort((a, b) => (a.phone < b.phone) ? 1 : ((b.phone < a
              .phone) ? -1 : 0));
          } else {
            this.filteredPaymentRequests = this.filteredPaymentRequests.sort((a, b) => (a.phone > b.phone) ? 1 : ((b.phone > a
              .phone) ? -1 : 0))
          }
        }
        if (column == 6) {
          if (this.asc_desc == "asc") {
            this.asc_desc = "desc";
            this.filteredPaymentRequests = this.filteredPaymentRequests.sort((a, b) => (a.amountStr < b.amountStr) ? 1 : ((b.amountStr < a.amountStr) ? -1 : 0));
          } else {
            this.asc_desc = "asc";
            this.filteredPaymentRequests = this.filteredPaymentRequests.sort((a, b) => (a.amountStr > b.amountStr) ? 1 : ((b.amountStr > a.amountStr) ? -1 : 0))
          }
        }
      },

    //-------------------- Common Methods
    async axiosGetData(myUrl, myData, what) {
      var loader = this.$loading.show({
              // Optional parameters
                color: '#03a9f3'
              });
      await axios({
        method: "post",
        url: myUrl,
        data: myData,
         headers:{
          Authorization: this.$store.getters.getAuthToken,
        }
      })
        .then((res) => {
          loader.hide();
          if (what === 1 || what === 12) {
            if (res.status == 200) {
              this.allPaymentRequests = res.data.list;
              this.filteredPaymentRequests = res.data.list;
              this.totalRows=res.data.dc.totalRow;
              this.totalPages = res.data.dc.totalPages;
            }
          } else if (what === 2) {
            //if(res.data.dc.auditFlag>0) {
            $("#reminder").modal("hide");
            //}
          } else if (what == 6) {
            this.allPaymentRequests = res.data;
            this.filteredPaymentRequests = res.data;
          }  if (what === 100) {
            this.successToastUpd();
            if (res.status == 200) {
              this.allPaymentRequests = res.data;
              this.filteredPaymentRequests = res.data;
            }
            location.reload();
          }
        })
        .catch(function (error) {
          if (error.response) {
            alert("-> " + error.response.data);
            alert("-> " + error.response.status);
            alert("-> " + error.response.headers);
          } else if (error.request) {
            this.lastErrorCode = 1;
            alert("No response " + error.request);
          } else {
            this.lastErrorCode = 1;
            alert("Error", error.message);
          }
        })
        .finally(() => {
          loader.hide();
          this.ResetLogoutTime();
        });
    }, // axiosGetData
  }, // methods

  watch: {
    allPaymentRequests: function () {
      try{
      for (let i = 0; i < this.allPaymentRequests.length; i++) {
        let dd = new Date(this.allPaymentRequests[i].dob);
        this.allPaymentRequests[i].dob = dd.toLocaleDateString();
        dd = new Date(this.allPaymentRequests[i].dos);
        this.allPaymentRequests[i].dos = dd.toLocaleDateString();
        dd = new Date(this.allPaymentRequests[i].billDate);
        this.allPaymentRequests[i].billDate = dd.toLocaleDateString();
        this.allPaymentRequests[i].billDateDate = dd;

        this.allPaymentRequests[i].monthYear = this.dateToYM(dd);
        this.allPaymentRequests[i].dateFull = this.dateToYMD(dd);

        this.allPaymentRequests[i].oldStatus =
          this.allPaymentRequests[i].status;
      }
      this.filteredPaymentRequests = this.allPaymentRequests;
      this.performFilter();
      }
       catch {
        /**/
      } finally {
        /**/
      this.filteredPaymentRequests = this.allPaymentRequests;
      this.performFilter();
      // this.$nextTick(() => {
      //   $("#table001").DataTable().destroy();
      //   $("#table001").DataTable({
      //       buttons: [
      //               'copy', 'csv', 'excel', 'pdf', 'print'
      //       ]
      //     });
      //     $('.buttons-copy, .buttons-csv, .buttons-print, .buttons-pdf, .buttons-excel').addClass('btn btn-primary mr-1');
      //   $(".table001").DataTable().draw();
      // });
      }
    },

// filteredPaymentRequests: function () {
//       this.$nextTick(() => {
//         $("#table001").DataTable().destroy();
//         $("#table001").DataTable({
//           buttons: ["copy", "csv", "excel", "pdf", "print"],
//         });
//         $(
//           ".buttons-copy, .buttons-csv, .buttons-print, .buttons-pdf, .buttons-excel"
//         ).addClass("btn btn-primary mr-1");
//         $(".table001").DataTable().draw();
//       }); // this.$nextTick
//     }, 
    
    initDate: function (val) {
      if (val == "") return;

      this.intDummyComm();
      this.dummyComm.myTime = "range";
      this.dummyComm.extras1 = this.dateToYMD(this.startDate);
      this.dummyComm.extras2 = this.dateToYMD(this.endDate);

      const url = this.SERVER + "/VNSPRAAPI/Trackers/GetActivePaidPaymentsList";

      this.axiosGetData(url, this.dummyComm, 1);

      this.performFilter();
    },

    "filter.monthYear": function (val) {
      this.filter.monthYear = this.dateToYMD(new Date(val));

      this.intDummyComm();
      this.dummyComm.myTime = "my";
      this.dummyComm.extras1 = this.filter.monthYear;

      const url = this.SERVER + "/VNSPRAAPI/Trackers/GetActivePaidPaymentsList";

      this.axiosGetData(url, this.dummyComm, 1);

      this.performFilter();
    },
  },

  mounted() {
    clearTimeout(this.loadObj);
    this.handleRole();
    this.loadInit();
  },
  unmounted() {
    clearTimeout(this.TimerObject);
  },
 // mounted
};
</script>

<style scoped>
  .float-textarea,
  .float-class:hover {
    border-top-style: hidden;
    border-right-style: hidden;
    border-left-style: hidden;
    background: transparent;
    border-bottom: 1px solid rgb(235, 235, 235);
    /* box-shadow: none; */
    width: 98%;
  }

  .float-textarea:focus {
    border-top-style: hidden;
    border-right-style: hidden;
    border-left-style: hidden;
    background: transparent;
    border-bottom: 2px solid rgb(240, 141, 11);
    /* box-shadow: none; */
    width: 98%;
  }

  .float-class,
  .float-class:hover {
    border-top-style: hidden;
    border-right-style: hidden;
    border-left-style: hidden;
    background: transparent;
    /* border-bottom: 2px solid rgb(240, 141, 11); */
    border-bottom: 1px solid rgb(235, 235, 235);
    box-shadow: none;
  }

  .float-class:focus {
    border-top-style: hidden;
    border-right-style: hidden;
    border-left-style: hidden;
    background: transparent;
    border-bottom: 2px solid rgb(240, 141, 11);
    box-shadow: none;
  }

  #font1 {
    font-weight: bold;
    font-size: 15px;
    margin-left: -7px;
  }

  .label_select {
    margin-top: -23px;
    margin-left: 0px;
  }

  .activeColor {
    background-color: #fb9678;
    color: white;
  }

  .colorActive {
    color: #f95c2e
  }

  .disabledColor {
    color: gray;
    background: lightgrey;
  }

  .asc-desc-btn {
    background-color: transparent;
    background-repeat: no-repeat;
    border: none;
    cursor: pointer;
    overflow: hidden;
    outline: none;
    color: honeydew;
    float: right;
  }

  .switch {
    position: relative;
    display: inline-block;
    width: 60px;
    height: 34px;
  }

  .switch input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    -webkit-transition: 0.4s;
    transition: 0.4s;
  }

  .slider:before {
    position: absolute;
    content: "";
    height: 26px;
    width: 26px;
    left: 4px;
    bottom: 4px;
    background-color: white;
    -webkit-transition: 0.4s;
    transition: 0.4s;
  }

  input:checked+.slider {
    background-color: #00c292;
  }

  input:focus+.slider {
    box-shadow: 0 0 1px #00c292;
  }

  input:checked+.slider:before {
    -webkit-transform: translateX(26px);
    -ms-transform: translateX(26px);
    transform: translateX(26px);
  }

  .slider.round {
    height: 34px;
    width: 56px;
    border-radius: 24px;
  }

  .slider.round:before {
    border-radius: 50%;
  }

  .label-color {
    color: black;
  }
</style>